import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { PublicFreemiumReportDetails } from '../../../models/PublicFreemiumReports/PublicFreemiumReports';

export const fetchPublicFreemiumReportDetails = createAsyncThunk(
    'publicFreemiumReports/fetchPublicFreemiumReportDetails',
    async (params: { reportId: number }, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get(`/api/PublicFreemiumReports/${params.reportId}`);

        if (response.status !== 200) {
            createNotification('Could not fetch the report details at the moment.', 'error');
            throw new Error('Failed to fetch public Free & Easy report details');
        }

        return response.data as PublicFreemiumReportDetails;
    }
);
